import { ChangeDetectionStrategy, Component, Input, OnChanges } from '@angular/core';
import { InvoiceSummary } from '../../../domain/use-cases/get-invoice-summary.use-case';

interface IndicatorItem {
  value: number;
  label: string;
  valueClass: string;
}

@Component({
  selector: 'app-invoice-summary',
  templateUrl: './invoice-summary.component.html',
  styleUrls: ['./invoice-summary.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class InvoiceSummaryComponent implements OnChanges {
  @Input({ required: true }) summary!: InvoiceSummary;

  items: IndicatorItem[] = [];

  ngOnChanges(): void {
    this.items = [
      { value: this.summary.issued, label: 'Emitidas',  valueClass: 'is-success' },
      { value: this.summary.errors, label: 'Com falha', valueClass: 'is-danger'  },
    ];
  }

  trackByLabel(_: number, item: IndicatorItem): string {
    return item.label;
  }
}
